import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps the per-location stock grid in sync with the selected variant.
 *
 * The grid is rendered server-side from the variant's custom.inventory metafield, so it must be
 * re-rendered per variant. variant-picker.js has already fetched and parsed the updated product
 * page by the time it dispatches variantUpdate, and passes it as event.detail.data.html - so this
 * needs no fetch of its own. Same approach as assets/product-inventory.js.
 */
class StockAvailability extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStock);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStock);
  }

  /**
   * Updates the per-location stock grid.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStock = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStock = event.detail.data.html.querySelector('stock-availability');

    // blocks/stock-availability.liquid always renders this element, empty when the variant has no
    // custom.inventory metafield. A missing element means the response wasn't the product page we
    // expected, so leave the current grid alone rather than blanking it.
    if (!newStock) return;

    morph(this, newStock, { childrenOnly: true });
  };
}

if (!customElements.get('stock-availability')) {
  customElements.define('stock-availability', StockAvailability);
}
